angular.module('vastdesk').
  component('imaVastPlayer', {
    bindings: {
      playerId: '@',
      vastUrl: '@'
    },
    template: '<div class="ima-player-container">' +
                '<video id="{{$imaVastPlayerCtrl.playerId}}-content" class="ima-content-player" playsinline muted></video>' +
                '<div id="{{$imaVastPlayerCtrl.playerId}}-ad-container" class="ima-ad-container" ng-class="{\'ima-ad-active\': $imaVastPlayerCtrl.active}"></div>' +
                // Center play button shown only before the ad has ever been requested.
                // Once clicked it is removed for good; play/pause then lives in the banner.
                '<button type="button" class="ima-play-button" ' +
                        'ng-show="!$imaVastPlayerCtrl.started" ' +
                        'ng-click="$imaVastPlayerCtrl.togglePlay()" aria-label="Play ad preview"></button>' +
              '</div>' +
              // Shared control row rendered BELOW the video so the entire ad surface
              // stays clickable for the VAST click-through. The banner is always visible;
              // play/pause after the initial center-button click happens here.
              '<player-controls ' +
                'playing="$imaVastPlayerCtrl.isPlaying()" ' +
                'muted="$imaVastPlayerCtrl.muted" ' +
                'current-time="$imaVastPlayerCtrl.currentTime" ' +
                'duration="$imaVastPlayerCtrl.duration" ' +
                'on-play-pause="$imaVastPlayerCtrl.togglePlay()" ' +
                'on-mute="$imaVastPlayerCtrl.toggleMute()"></player-controls>',
    controllerAs: '$imaVastPlayerCtrl',
    controller: ['$interval', function($interval) {

      var self = this;
      var adsManager;
      var adsLoader;
      var adDisplayContainer;
      var resizeTimeout;
      var progressTimer;

      self.started = false;
      self.active = false;
      self.paused = false;
      self.muted = true;
      self.currentTime = 0;
      self.duration = 0;

      // Playing = an ad session is active and not paused. Drives the play/pause glyph.
      self.isPlaying = function() {
        return self.active && !self.paused;
      };

      var onWindowResize = function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          if (!adsManager) return;
          var videoElement = document.getElementById(self.playerId + '-content');
          if (!videoElement) return;
          adsManager.resize(videoElement.clientWidth, videoElement.clientHeight, google.ima.ViewMode.NORMAL);
        }, 100);
      };

      window.addEventListener('resize', onWindowResize);

      var hasVastUrl = function() {
        return self.vastUrl &&
          self.vastUrl !== 'undefined' &&
          self.vastUrl !== 'null';
      };

      // Upgrades http:// to https:// so the browser's mixed-content policy
      // does not block ad tag requests on HTTPS pages.
      var normalizeVastUrl = function(url) {
        return url.replace(/^http:\/\//i, 'https://');
      };

      var resetPlayer = function() {
        stopProgressTimer();
        self.active = false;
        self.paused = false;
        self.currentTime = 0;
        self.duration = 0;
      };

      var startProgressTimer = function() {
        stopProgressTimer();
        progressTimer = $interval(updateAdProgress, 250);
      };

      var stopProgressTimer = function() {
        if (progressTimer) {
          $interval.cancel(progressTimer);
          progressTimer = null;
        }
      };

      var updateAdProgress = function() {
        if (!adsManager) return;
        var remaining = adsManager.getRemainingTime();
        var currentAd = adsManager.getCurrentAd();
        var reported = currentAd ? currentAd.getDuration() : 0;
        // Keep the last known-good duration; IMA can transiently report <= 0
        // (e.g. during volume changes), which would otherwise zero the progress bar.
        var duration = reported > 0 ? reported : self.duration;
        var current = duration > 0 && remaining >= 0 ? duration - remaining : self.currentTime;
        self.duration = duration > 0 ? duration : 0;
        self.currentTime = current > 0 ? current : 0;
      };

      var onAdsManagerLoaded = function(adsManagerLoadedEvent) {
        var videoElement = document.getElementById(self.playerId + '-content');
        adsManager = adsManagerLoadedEvent.getAdsManager(videoElement);

        adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, onAdError);
        adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, onAdStarted);
        adsManager.addEventListener(google.ima.AdEvent.Type.PAUSED, onAdPaused);
        adsManager.addEventListener(google.ima.AdEvent.Type.RESUMED, onAdResumed);
        adsManager.addEventListener(google.ima.AdEvent.Type.VOLUME_CHANGED, onAdVolumeChanged);
        adsManager.addEventListener(google.ima.AdEvent.Type.VOLUME_MUTED, onAdVolumeChanged);
        adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, onContentResumeRequested);
        adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, onAllAdsCompleted);

        try {
          var width = videoElement ? videoElement.clientWidth || 640 : 640;
          var height = videoElement ? videoElement.clientHeight || 360 : 360;
          adsManager.init(width, height, google.ima.ViewMode.NORMAL);
          adsManager.setVolume(self.muted ? 0 : 1);
          adsManager.start();
        } catch (adError) {
          resetPlayer();
        }
      };

      var onAdStarted = function() {
        if (adsManager) {
          adsManager.setVolume(self.muted ? 0 : 1);
        }
        self.active = true;
        self.paused = false;
        updateAdProgress();
        startProgressTimer();
      };

      var onAdPaused = function() {
        self.paused = true;
      };

      var onAdResumed = function() {
        self.paused = false;
      };

      var onAdVolumeChanged = function() {
        if (!adsManager) return;
        self.muted = adsManager.getVolume() === 0;
      };

      var onAdError = function() {
        if (adsManager) {
          adsManager.destroy();
          adsManager = null;
        }
        resetPlayer();
      };

      var onContentResumeRequested = function() {
        if (adsManager) {
          adsManager.destroy();
          adsManager = null;
        }
        resetPlayer();
      };

      var onAllAdsCompleted = function() {
        if (adsManager) {
          adsManager.destroy();
          adsManager = null;
        }
        resetPlayer();
      };

      // Play/pause and mute are driven by the control row below the video. The ad
      // surface itself is left untouched so IMA's native click-through opens the
      // advertiser landing page when the ad is clicked.

      // The play button does double duty: while no ad session is active it requests
      // the ad (the required user gesture for IMA — also used to replay after the ad
      // completes); once an ad is playing it toggles play/pause. The first click also
      // flips `started`, which permanently removes the center play button.
      self.togglePlay = function() {
        self.started = true;
        if (!self.active) {
          requestAd();
          return;
        }
        if (!adsManager) return;
        if (self.paused) {
          adsManager.resume();
          self.paused = false;
        } else {
          adsManager.pause();
          self.paused = true;
        }
      };

      self.toggleMute = function() {
        if (!adsManager) return;
        self.muted = !self.muted;
        adsManager.setVolume(self.muted ? 0 : 1);
      };

      var requestAd = function() {
        if (!hasVastUrl() || typeof google === 'undefined' || !google.ima) {
          return;
        }

        var videoElement = document.getElementById(self.playerId + '-content');
        var adContainerEl = document.getElementById(self.playerId + '-ad-container');

        if (!videoElement || !adContainerEl) {
          return;
        }

        // Fully reinitialize on each play. Clearing the container DOM and
        // recreating AdDisplayContainer + AdsLoader avoids stale state from
        // the previous session that would silently block replay.
        adContainerEl.innerHTML = '';

        adDisplayContainer = new google.ima.AdDisplayContainer(adContainerEl, videoElement);
        adDisplayContainer.initialize();

        adsLoader = new google.ima.AdsLoader(adDisplayContainer);
        adsLoader.addEventListener(
          google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
          onAdsManagerLoaded,
          false
        );
        adsLoader.addEventListener(
          google.ima.AdErrorEvent.Type.AD_ERROR,
          onAdError,
          false
        );

        var adsRequest = new google.ima.AdsRequest();
        adsRequest.adTagUrl = normalizeVastUrl(self.vastUrl);
        adsRequest.linearAdSlotWidth = videoElement.clientWidth || 640;
        adsRequest.linearAdSlotHeight = videoElement.clientHeight || 360;
        adsLoader.requestAds(adsRequest);
      };

      this.$onDestroy = function() {
        window.removeEventListener('resize', onWindowResize);
        stopProgressTimer();
        clearTimeout(resizeTimeout);
        if (adsManager) {
          adsManager.destroy();
        }
        if (adsLoader) {
          adsLoader.destroy();
        }
      };

    }]
  });
